// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YfLB","label":"styles_label__3Bxsl"};